import React from "react";
import { connect } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faShoppingCart,
  faMapMarkerAlt,
  faReceipt,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";
import CartTable from "./CartTable";
import OrderForm from "./OrderForm";
import OrderConfirmation from "./OrderConfirmation";
import OrderCompleted from "./OrderCompleted";
import { sendOrder } from "../firebase/orders";
import { resetCart } from "../actions/cartAction";

class CartModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 1,
      info: {
        name: "",
        phone: "",
        email: "",
        address: "",
      },
      buttonColor1: "secondary",
      buttonColor2: "secondary",
      buttonColor3: "secondary",
    };
  }
  activeForm1 = () => {
    this.setState({
      currentStep: 1,
    });
  };
  activeForm2 = () => {
    this.setState({
      currentStep: 2,
    });
  };
  activeForm3 = () => {
    this.setState({
      currentStep: 3,
    });
  };
  onChange = (state) => {
    this.setState({
      info: {
        ...this.state.info,
        ...state,
      },
    });
  };

  canBeSubmitted = () => {
    const { name, phone, email, address } = this.state.info;
    return (
      name.length > 0 &&
      phone.length > 0 &&
      email.length > 0 &&
      address.length > 0
    );
  };

  _next = () => {
    let currentStep = this.state.currentStep;
    if (currentStep === 3) {
      let total = 0;
      let quantity = 0;
      let items = this.props.items.map((item) => {
        let product = this.props.products[item.product];
        let sub = product.items.find((s) => s.id === item.item);
        total += item.quantity * sub.price;
        quantity += item.quantity;
        return {
          category: product.category.name,
          product: product.name,
          productId: item.product,
          item: sub.size,
          itemId: item.item,
          price: sub.price,
          quantity: item.quantity,
        };
      });
      let orders = {
        items: items,
        info: { ...this.state.info },
        total: total,
        quantity: quantity,
      };
      sendOrder(orders).then(() => this.props.resetCart());
    }
    currentStep = currentStep >= 3 ? 4 : currentStep + 1;
    this.setState({
      currentStep: currentStep,
    });

    if (currentStep == 2) {
      this.setState({ buttonColor1: "success" });
    }
    if (currentStep == 3) {
      this.setState({ buttonColor2: "success" });
    }
    if (currentStep == 4) {
      this.setState({ buttonColor3: "success" });
      this.setState({
        info: {
          name: "",
          phone: "",
          email: "",
          address: "",
        },
      });
    }
  };

  _prev = () => {
    let currentStep = this.state.currentStep;
    currentStep = currentStep <= 1 ? 1 : currentStep - 1;
    this.setState({
      currentStep: currentStep,
    });
  };
  previousButton() {
    let currentStep = this.state.currentStep;
    if (currentStep > 1 && currentStep < 4) {
      return (
        <button
          className="btn btn-prev btn-secondary"
          type="button"
          onClick={this._prev}
        >
          Quay về
        </button>
      );
    }
    return null;
  }

  nextButton() {
    let currentStep = this.state.currentStep;
    if (currentStep == 1) {
      return (
        <button
          className="btn btn-next float-right"
          onClick={this._next}
          disabled={this.props.items.length > 0 ? false : true}
        >
          Tiếp theo
        </button>
      );
    } else if (currentStep < 4) {
      return (
        <button
          className="btn btn-next float-right"
          onClick={this._next}
          disabled={
            this.props.items.length > 0 && this.canBeSubmitted() ? false : true
          }
        >
          Tiếp theo
        </button>
      );
    } else {
      return (
        <button
          className="btn btn-next float-right"
          onClick={() => {
            this.props.onHide();
            this.setState({
              currentStep: 1,
              buttonColor1: "secondary",
              buttonColor2: "secondary",
              buttonColor3: "secondary",
            });
          }}
        >
          Đóng
        </button>
      );
    }
  }

  render() {
    let total = 0;
    return (
      <div>
        <Modal
          dialogClassName="cart-modal"
          show={this.props.isOpen}
          onHide={this.props.onHide}
        >
          <Modal.Body>
            <div className="step-bar" key="full">
              <Button variant="success" onClick={this.activeForm1}>
                <FontAwesomeIcon icon={faShoppingCart} />
              </Button>
              <div className="step-bar-line"></div>
              <Button
                variant={this.state.buttonColor1}
                onClick={() => {
                  this.activeForm2();
                  this.setState({ buttonColor1: "success" });
                }}
                disabled={this.props.items.length ? false : true}
              >
                <FontAwesomeIcon icon={faMapMarkerAlt} />
              </Button>
              <div className="step-bar-line"></div>
              <Button
                variant={this.state.buttonColor2}
                onClick={() => {
                  this.activeForm3();
                  this.setState({ buttonColor2: "success" });
                }}
                disabled={!this.canBeSubmitted()}
              >
                <FontAwesomeIcon icon={faReceipt} />
              </Button>
              <div className="step-bar-line"></div>
              <Button
                variant={this.state.buttonColor3}
                disabled={!this.canBeSubmitted()}
              >
                <FontAwesomeIcon icon={faCheck} />
              </Button>
            </div>

            {this.state.currentStep == 1 && <CartTable readOnly={false} />}
            {this.state.currentStep == 2 && (
              <OrderForm value={this.state.info} onChange={this.onChange} />
            )}
            {this.state.currentStep == 3 && (
              <OrderConfirmation value={this.state.info} />
            )}
            {this.state.currentStep == 4 && <OrderCompleted />}

            {this.previousButton()}
            {this.nextButton()}
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    items: state.items,
    quantity: state.quantity,
    products: state.products,
    categories: state.categories,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    resetCart() {
      dispatch(resetCart());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CartModal);
